export default "__VITE_ASSET__CAWB1G9u__"